'use strict';
/**
 *  Load modules
 */

import AOS from 'aos';
import mobileNav from './modules/mobileNav';
import newsSlider from "./modules/newsSlider";
import testimonialsSlider from "./modules/testimonialsSlider";
import howItWorks from "./modules/howItWorks";
import readMore from "./modules/readMore";
import underlineText from "./modules/underlineText";
import filter from "./modules/filter";
import faq from "./modules/faq";
import teamSlider from "./modules/teamSlider";
import teamBlock from "./modules/teamBlock";
import headerScroll from "./modules/headerScroll";
import '../scss/app.scss';
$(document).ready(function () {
  AOS.init();
  newsSlider();
  testimonialsSlider();
  howItWorks();
  readMore();
  underlineText();
  faq();
  teamSlider();
  teamBlock();
  headerScroll();
});